export const NUMERIC = /\d/v;
export const NUMERIC_WITH_DOT = /[\d.]/v;
export const ALPHANUMERIC_WITH_SPECIAL_SYMBOLS_EXCEPT_COMMA = /^[^,]+$/v;
export const ONLY_LATIN_AND_SPECIAL_SYMBOLS =
  /^[\w\u00C0-\u00FF\s'.,[\]/#@!№$%^&?<>*+|€;:{}="`~()-]+$/u;
export const START_WITH_HTTP_OR_FORWARD_SLASH = /^(?:https?|\/)/v;
export const CODE = /^[A-Z0-9]+$/iv;
export const UUID =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/iv;
